import request from 'superagent';
import { browserHistory } from 'react-router';
import { startLoad, finishLoad } from './loader';
import { selectTask, getEditableTasks } from './tasks';
import { addError } from './utils';

function receiveCourses(courses) {
  return {
    type: 'RECEIVE_COURSES',
    courses,
  };
}

export function receiveCourse(course) {
  return {
    type: 'RECEIVE_COURSE',
    course,
  };
}

export function receiveCompletition(completition) {
  return {
    type: 'RECEIVE_COMPLETITION',
    completition,
  };
}

export function unselectCourse() {
  return {
    type: 'UNSELECT_COURSE',
  };
}

export function getCourses(silent) {
  return dispatch => {
    if (!silent) dispatch(startLoad('getCourses', 'Получение всех курсов'));
    request.post('/course/list').end((err, res) => {
      if (!silent) dispatch(finishLoad('getCourses'));
      if (err) {
        dispatch(receiveCourses([]));
      } else {
        dispatch(receiveCourses(res.body));
      }
    });
  };
}

export function getPlatformCourses(platform) {
  return dispatch => {
    request.post(`/course/list/${platform}`).end((err, res) => {
      if (err) {
        if (res && res.status === 401) {
          return;
        }
        dispatch(addError(err));
        dispatch(receiveCourses([]));
      } else {
        dispatch(receiveCourses(res.body));
      }
    });
  };
}

export function getAdminCourses() {
  return dispatch => {
    dispatch(
      startLoad(
        'getAdminCourses',
        'Получение всех курсов, доступных для редактирования'
      )
    );
    request.post('/course/list/editable').end((err, res) => {
      dispatch(finishLoad('getAdminCourses'));
      if (err) {
        dispatch(receiveCourses([]));
      } else {
        dispatch(receiveCourses(res.body));
      }
    });
  };
}

export function getCourse(type) {
  return dispatch => {
    dispatch(startLoad('getCourse', 'Получение выбранного курса'));
    request
      .post('/course/getCourse')
      .send({ type })
      .end((err, res) => {
        dispatch(finishLoad('getCourse'));
        if (err) {
          dispatch(addError(res.body));
        } else {
          dispatch(receiveCourse(res.body));
        }
      });
  };
}

export function getCourseById(_id, edit, task) {
  return dispatch => {
    dispatch(startLoad('getCourse', 'Получение выбранного курса'));
    request
      .post(`/course/get/${_id}`)
      .send({ _id })
      .end((err, res) => {
        dispatch(finishLoad('getCourse'));
        if (err) {
          dispatch(receiveCourse(null));
        } else {
          dispatch(receiveCourse(res.body));
          if (!edit) dispatch(getEditableTasks(res.body._id, false, task));
        }
      });
  };
}

export function updateCourseCompletition(id) {
  return dispatch => {
    request.post(`/course/completition/${id}`).end((err, res) => {
      if (err) {
        dispatch(addError(res.body));
      } else {
        dispatch(receiveCompletition(res.body.completition));
      }
    });
  };
}

export function switchCourse(newCourseId, redirect, saveTask) {
  return dispatch => {
    if (!saveTask) dispatch(selectTask(0, 0));
    request
      .post('/user/switchCourse')
      .send({ newCourseId })
      .end((err, res) => {
        if (err) {
          dispatch(addError(res.body));
        } else {
          dispatch(receiveCourse(res.body.course));

          if (redirect) {
            browserHistory.push(
              '/i/' + res.body.course.type + '/' + res.body.course._id
            );
          }
        }
      });
  };
}

export function selectCourse(id) {
  return {
    type: 'SELECT_COURSE',
    id,
  };
}

export function updateCourse(course, silent) {
  return dispatch => {
    dispatch(startLoad('updateCourse', 'Обновление курса'));
    request
      .post('/course/update')
      .send({ course })
      .end((err, res) => {
        dispatch(finishLoad('updateCourse'));
        if (err) {
          dispatch(receiveCourses([]));
          dispatch(receiveCourse(null));
        } else {
          dispatch(receiveCourse(res.body.updatedCourse));
          if (!silent) dispatch(getEditableTasks(res.body.updatedCourse._id));
          dispatch(receiveCourses(res.body.courses));
        }
      });
  };
}

export function createCourse() {
  return dispatch => {
    dispatch(startLoad('createCourse', 'Создание курса'));
    request.post('/course/create').end((err, res) => {
      dispatch(finishLoad('createCourse'));
      if (err) {
        dispatch(receiveCourses([]));
      } else {
        dispatch(receiveCourses(res.body));
        //dispatch(selectCourse(res.body.length - 1));
      }
    });
  };
}

export function deleteCourse(_id) {
  return dispatch => {
    dispatch(startLoad('deleteCourse', 'Удаление курса'));
    request.delete(`/course/${_id}`).end((err, res) => {
      dispatch(finishLoad('deleteCourse'));
      if (err) {
        dispatch(receiveCourses([]));
      } else {
        dispatch(receiveCourses(res.body));
        //dispatch(selectCourse(res.body.length - 1));
      }
    });
  };
}

export function findTask(_id) {
  return dispatch => {
    dispatch(startLoad('findTask', 'Ищем задание'));
    request
      .get(`/course/find/${_id}`)
      .end((err, { body: { course, section, theme, lesson, task } }) => {
        dispatch(finishLoad('findTask'));
        if (err) {
          dispatch(addError('Ничего не найдено, возможно ID неверный'));
        } else {
          browserHistory.push(
            `/i/gui/admin?course=${course}&section=${section}&theme=${theme}&lesson=${lesson}&task=${task}`
          );
        }
      });
  };
}
